export const ITEMS_PER_PAGE = 10;

export const INITIAL_ALLOTMENT_STATE = {
  name: '',
  image_url: '',
  is_active: true,
};
